import { Button, Stack, Typography } from '@mui/material';
import { useNavigate } from '@tanstack/react-router';

import { FC } from 'react';

export const DefaultNotFoundComponent: FC = () => {
  const navigate = useNavigate();

  return (
    <Stack alignItems='center' spacing={4} textAlign='center'>
      <div>
        <Typography component='h1' mb={2} variant='h3'>
          Page Not Found
        </Typography>
        <Typography variant='body1'>
          The page you are looking for does not exist.
        </Typography>
      </div>
      <Button
        onClick={() => navigate({ to: '/organizations' })}
        variant='contained'>
        Go to Organizations
      </Button>
    </Stack>
  );
};

DefaultNotFoundComponent.displayName = 'DefaultNotFoundComponent';
